<template>
  <div v-loading="dialogVisible" class="helpIndexPage">
    <div class="leftContent">
      <p class="flex_bet flex_align_center helpHeader">
        <span>{{ $t('doc.helpCenter') }}</span>
        <el-button v-if="isAdmin & company.id==4" type="primary" icon="el-icon-plus" size="mini" @click="toAddOrEdit()" />
      </p>
      <el-menu v-for="(meun,index) in tabList" :key="index" :default-active="titleCurrentKey" class="el-menu-vertical" @select="select">
        <el-submenu :index="meun.key">
          <template slot="title">
            <span :title="meun.value">{{ meun.value }}</span>
          </template>
          <el-menu-item-group v-for="(item,i) in meun.titleList" :key="i">
            <el-menu-item :index="item.menu" :title="item.valueI18n">{{ item.valueI18n }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>

    <div class="rightContent">
      <div class="title">
        <div v-if="isAdmin & company.id==4" style="text-align: right;">
          <el-button type="primary" size="mini" icon="el-icon-edit" style="margin-left: 20px;" @click="toAddOrEdit(titleCurrentKey)" />
          <el-button type="primary" size="mini" class="el-button el-button--danger el-button--small" icon="el-icon-close" @click="toDeleteDoc(currentKey)" />
        </div>
        <h2>{{ title }}</h2>
      </div>
      <div class="content" v-html="content" />
    </div>
  </div>
</template>

<script>
import { detailDoc, deleteDoc, platformListLang, platformMenuList } from '@/api/doc'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      dialogVisible: true,
      currentKey: this.$route.query.currentKey ? this.$route.query.currentKey : '',
      title: '',
      content: '',
      currentModel: {},

      tabList: [],
      tabCurrentKey: '', // 当前tab的key
      titleCurrentKey: '', // 当前标题的key
      lang: ''
    }
  },
  computed: {
    ...mapState(['language', 'webInfo', 'isAdmin', 'company'])
  },
  watch: {
    '$i18n.locale'(val) {
      this.queryList()
    }
  },
  mounted() {
    this.tabCurrentKey = localStorage.getItem('tabCurrentKey') || ''
    this.titleCurrentKey = localStorage.getItem('titleCurrentKey') || ''
    setTimeout(() => {
      this.queryList()
    }, 1000)
  },
  methods: {
    queryList() { // 获取分类
      platformListLang(this.$i18n.locale).then(res => {
        console.log(res)
        if (res.resultCode == 1001) {
          this.lang = this.language[0].toUpperCase() + this.language.slice(1)// 因为后台返回的字段是Fr等
          if (this.language == 'zh_CN' || this.language == 'zh_HK') {
            this.lang = this.language == 'zh_CN' ? 'ZhCn' : 'ZhHk'
          }
          if (!this.webInfo.webUrl) { // GPD
            this.tabList = res.resultModel || []
          } else {
            var moduleArr = (this.webInfo && this.webInfo.onlineHandbookModule) ? this.webInfo.onlineHandbookModule.split(',') : []
            this.tabList = []
            var arr = res.resultModel || []
            arr.forEach(v => {
              if (moduleArr.indexOf(v.key) > -1) {
                this.tabList.push(v)
              }
            })
          }
          if (!this.tabList.length) return
          if (!this.tabCurrentKey) this.tabCurrentKey = this.tabList[0].key
          this.tabList.forEach(v => {
            v.titleList = []
            this.getTypeDetailListLang(v.key)// 把所有标题都加载出来
          })
        }
      })
    },
    getTypeDetailListLang(val) { // 获取分类下的标题
      platformMenuList({ platform: val || this.tabCurrentKey }).then(res => {
        if (res.resultCode == 1001) {
          this.tabList.forEach((v, i) => {
            if (v.key == val && res.resultModel.length) {
              if (!this.titleCurrentKey && val == this.tabCurrentKey) this.titleCurrentKey = res.resultModel[0].menu
              res.resultModel.forEach(m => {
                var obj = JSON.parse(JSON.stringify(m))
                obj.valueI18n = obj['value' + this.lang] || obj['valueEn']// 如果该语言的标题不存在，则用英语代替
                this.tabList[i].titleList.push(obj)
              })
            }
          })
          this.tabList = [...this.tabList]
          this.dialogVisible = false
          // console.log('***this.tabList', this.tabList)
          if (val == this.tabCurrentKey) this.queryDetail({ menu: this.titleCurrentKey }, null)
        }
      })
    },
    I18nTitleContent() { // 标题和内容国际化
      this.title = this.currentModel.title['value' + this.lang] || this.currentModel.title['valueEn']// 如果该语言不存在，则用英语代替
      this.content = this.currentModel.content['value' + this.lang] || this.currentModel.content['valueEn']// 如果该语言不存在，则用英语代替
    },
    queryDetail(param, obj) {
      detailDoc({ platform: this.tabCurrentKey, menu: param.menu }).then(response => {
        if (response.resultCode != 1001 || !response.resultModel) {
          this.title = ''
          this.content = ''
          this.currentKey = ''
          this.currentModel = {}
          return
        }
        this.currentKey = response.resultModel.content.menu
        this.currentModel = response.resultModel
        this.I18nTitleContent()
      })
    },
    select(key, keyPath) {
      console.log(key, keyPath)
      if (keyPath) {
        this.tabCurrentKey = keyPath[0]
        localStorage.setItem('tabCurrentKey', this.tabCurrentKey)
      }
      if (key) {
        this.titleCurrentKey = key
        localStorage.setItem('titleCurrentKey', this.titleCurrentKey)
        this.queryDetail({ menu: this.titleCurrentKey }, null)
      }
    },
    toAddOrEdit(val) {
      this.$router.push({
        path: '/doc/save',
        query: {
          currentKey: val,
          currentPlatform: this.tabCurrentKey
        }
      })
    },
    toDeleteDoc(param) {
      this.$confirm(this.$t('button.ConfirmDelete'), '', {
        confirmButtonText: this.$t('button.Confirm'), // '确定',
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteDoc({
          isDeleteLink: 1,
          menu: this.currentKey,
          platform: this.tabCurrentKey
        }).then(res => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: this.$t('warningSet.submitted') // 成功
            })
            this.queryList()
          } else {
            this.$message({
              type: 'error',
              message: res.resultMessage // 失败
            })
          }
        })
      }).catch(() => {})
    },
    selectChanged(value) {
      this.queryList()
    }
  }
}
</script>

<style scoped>
.helpIndexPage{
  display: flex;
  justify-content: space-between;
  height: 100%;
  overflow:hidden;
}
.leftContent {
  width: 22%;
  background-color: white;
  padding: 30px 10px;
  border-radius: 10px;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.helpHeader{
  margin-bottom: 20px;
}
.rightContent {
  width: calc(78% - 20px);
  background-color: white;
  border-radius: 10px;
  max-height: 100%;
  overflow-y: auto;
  padding: 20px;
}

.title {
  text-align: center;
  padding-top: 10px;
}
.title,h2{

  min-height: 37px;
}
</style>

